// @flow
import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import { fonts } from '@peachjar/components';
import { css } from 'react-emotion';

import ReferralCodeSection from './ReferralCodeSection';

const { ProximaNova } = fonts;

type State = {|
  inputVisible: boolean,
|};

type Props = {|
  handleTempDiscountCodeInput: Function,
|};

const styles = {
  link: css({ color: '#3a833c' }),
  wrapper: css({
    fontFamily: ProximaNova,
    marginTop: '20px',
  }),
};

class ReferralBox extends Component<Props, State> {
  state = {
    inputVisible: true,
  };

  toggleReferralBox = (): void => {
    this.setState({ inputVisible: !this.state.inputVisible });
  };

  render() {
    const {
      handleTempDiscountCodeInput,
      numberOfSchools,
      discountLoading,
      discountNetworkStatus,
    } = this.props;
    return (
      <div className={styles.wrapper}>
        <ReferralCodeSection
          handleTempDiscountCodeInput={handleTempDiscountCodeInput}
          inputVisible={this.state.inputVisible}
          numberOfSchools={numberOfSchools}
          discountLoading={discountLoading}
          discountNetworkStatus={discountNetworkStatus}
        />
      </div>
    );
  }
}

ReferralBox = reduxForm({
  form: 'onboarding', //                 <------ same form name
  destroyOnUnmount: false, //        <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  // validate,
})(ReferralBox);

export default ReferralBox;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/components/ReferralBox.jsx